import { connect } from 'react-redux';
import Transactions from './Transactions';
import React from 'react';
import { ILinesHandle, ILinesProperties } from './Transactions.properties';

// const params = new URLSearchParams(location.search);

const mapStateToProps = () => ({
    selectedMovementEnquiryId: '', //purchaseOrdersSelectors.selected(state)?.PurchaseOrder ?? params.get('PurchaseOrder'),
});

const ContainerComponent = (props: Omit<ILinesProperties, 'classes' | 'calculateCellValueChange'> & { forwardRef?: React.Ref<ILinesHandle> }) => {

    return <Transactions
        {...props}
        innerRef={props?.forwardRef}
    />;
};

export default connect(mapStateToProps, null)(React.forwardRef(ContainerComponent));
